import companyType from '../person/company-type.js';

const PERCENTAGE = 1;
const VALUABLE = 2;

export default {
  PERCENTAGE,
  VALUABLE,
  fromCompanyType: type => {
    const map = new Map([
      [companyType.SPOLKA_CYWILNA, PERCENTAGE],
      [companyType.SPOLKA_JAWNA, PERCENTAGE],
      [companyType.SPOLKA_PARTNERSKA, PERCENTAGE],
      [companyType.SPOLKA_ZOO, VALUABLE],
    ]);

    return map.get(type) || PERCENTAGE;
  },
};
